import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 39,
	viewBox: "0 0 44 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_12733_4539)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22.1714 38.4583L43.7045 0.8125H0.643555L22.1714 38.4583Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4912 17.8483H31.8892C32.3829 17.8483 32.4687 17.9296 32.4473 18.4225C32.3239 21.9433 29.3941 24.695 25.9009 24.5704C22.4078 24.4458 19.6873 21.4883 19.8107 17.9621C19.9287 14.6146 22.5902 11.9333 25.9009 11.8142C26.3785 11.7979 26.4858 11.8954 26.4858 12.3721V17.8429L26.4912 17.8483Z",
					fill: "#084384"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.666 13.3143V10.4705C27.666 10.0155 27.7519 9.93428 28.2133 9.9397C31.5563 10.0426 34.2392 12.7618 34.3411 16.1364C34.3411 16.5643 34.2392 16.678 33.826 16.678H28.1811C27.768 16.678 27.6714 16.5751 27.666 16.1689V13.3197V13.3143Z",
					fill: "#084384"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2728 10.4326C23.9581 10.5897 22.6972 11.0772 21.6186 11.8572C21.6133 11.7272 21.6025 11.6405 21.6025 11.5592V4.23591C21.6025 3.79716 21.6938 3.70508 22.1177 3.70508H24.8542C25.1708 3.70508 25.2996 3.82424 25.2996 4.12758V10.3351C25.2996 10.3676 25.2889 10.4001 25.2782 10.4326H25.2728Z",
					fill: "#084384"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.7463 7.9743H17.1278C16.6502 7.9743 16.5536 8.0718 16.5536 8.55388V17.4643H15.2175V6.3168C15.2175 5.85096 15.1156 5.74805 14.6595 5.74805H12.159C11.5741 5.74805 11.5044 5.81305 11.5044 6.39805V17.4697H10.1683V10.791C10.1683 10.401 10.0663 10.2926 9.67461 10.2926H7.02925C6.54632 10.2926 6.47656 10.3685 6.47656 10.8505V11.1972L10.9034 18.9376H18.0775C18.1849 18.9376 18.2868 18.9214 18.3941 18.9214V18.6451C18.2868 16.6951 18.9092 14.7776 20.1327 13.2664C20.2078 13.1635 20.2453 13.0389 20.2507 12.9143V8.49971C20.2507 8.08805 20.1434 7.98513 19.741 7.98513L19.7463 7.9743Z",
					fill: "#084384"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12733_4539",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 44,
				height: 39,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDashboardIcon);
export default ForwardRef;
